import { DeckModel } from '@/models/deck';
import { CardModel } from '@/models/card';

import * as ping        from '@/lib/usage_ping';
import { hitwall }      from '@/lib/helpers/paywall';
import { functions }    from '@/db/firestore';
import { Repository }   from '@/db/_repo';

import store from '@/store';

const db = new Repository();

async function addDeck(thisUID, that) {
    const newCard: CardModel = db.cards.empty();
    const newDeck: DeckModel = { 
        name: 'New Deck',
        createdBy: thisUID,
        createdAt: db.now,
        cards: [ newCard ],
        roles: {
            [thisUID]: 'owner'
        }
    };
    ping.send({ type: ping.DeckUsage.add, uid: thisUID });
    if (that.isTourSkip) ping.send({ type: ping.UserUsage.skiptour, uid: thisUID});

    const canAdd = await db.licensing.canAddDeck(thisUID);

    if (canAdd) {
        db.decks.addAsync(newDeck)
        .then((val: DeckModel) => {
            store.commit('ADD_PRIVATE_DECKS', val);
            functions.httpsCallable('updateUserUsage')({ userId: thisUID }).catch(e => console.error(e));
            that.$router.push(`/app/deck/${val.id}/edit`);
        })
        .catch(e => {
            console.log("Error adding new deck!")
            console.error(e);
        })
    } else {
        hitwall(that, ping.SubscriptionUsage.deckpaywall, thisUID);
    }
}

export default addDeck;
